import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { selectResources, selectUiStatus, selectFlow, selectMinimal } from './store/selectors';
import Insurances from './containers/insurances';
import Contact from './containers/contact';
import { initApp } from './store/form-actions';
import { LoadingSpinner, Section, ErrorPage } from 'migration-flos-react';
import ContactOption from './containers/contact-option';
import InsuranceGuide from './components/insurance-guide';
import './App.css';

const AppContainer = ({ isBusy, hasTechnicalError, isInsuranceGuide, init, resources, minimal }) => {
    useEffect(() => {
        init();
    }, [init]);

    if (isBusy) {
        return <LoadingSpinner />;
    }

    if (hasTechnicalError) {
        return <ErrorPage resources={resources} />;
    }

    return (
        <Section variant="alt">
            {isInsuranceGuide ? <InsuranceGuide /> : null}
            <Insurances />
            <Contact />
            <ContactOption />
        </Section>
    );
};

const mapStates = (state) => ({
    resources: selectResources(state),
    isBusy: selectUiStatus(state) === 'loading',
    hasTechnicalError: selectUiStatus(state) === 'error',
    isInsuranceGuide: selectFlow(state) === 'INSURANCE_GUIDE',
    minimal: selectMinimal(state)
});

const mapDispatch = (dispatch, ownProps) => ({
    init: () => dispatch(initApp(ownProps.config))
});

const App = connect(mapStates, mapDispatch)(AppContainer);

export default App;
